<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Faq</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/faq">Faq</router-link>
        </li>
        <li class="active">
          <strong>Nowy</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isPlOpen = !isPlOpen">
            <h5>Opis faq [pl]</h5>
            <span :class="chevronPlClass" class="ibox-toggle"></span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isPlOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="faqObj.title_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Tytuł"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.title_pl" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.title_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="faqObj.description_pl"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isEnOpen = !isEnOpen">
            <h5>Opis faq [en]</h5>
            <span :class="chevronEnClass" class="ibox-toggle"></span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isEnOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="faqObj.title_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Tytuł"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.title_en" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.title_en[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="faqObj.description_en"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isDeOpen = !isDeOpen">
            <h5>Opis faq [de]</h5>
            <span :class="chevronDeClass" class="ibox-toggle"></span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isDeOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="faqObj.title_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Tytuł"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.title_de" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.title_de[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="faqObj.description_de"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isDeDeOpen = !isDeDeOpen">
            <h5>Opis faq [de_de]</h5>
            <span :class="chevronDeDeClass" class="ibox-toggle"></span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isDeDeOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="faqObj.title_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="faqObj.description_cpde"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isDeEnOpen = !isDeEnOpen">
            <h5>Opis faq [de_en]</h5>
            <span :class="chevronDeEnClass" class="ibox-toggle"></span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isDeEnOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="faqObj.title_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="faqObj.description_cpen"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isConfigOpen = !isConfigOpen">
            <h5>Dane faq</h5>
            <span :class="chevronConfigClass" class="ibox-toggle"></span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isConfigOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Sekcja</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="faqObj.section"
                    mode="single"
                    placeholder="Sekcja"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="faqSections"
                  >
                  </Multiselect>
                  <div v-if="errorsAdminData?.data?.section" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.section[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="hr-line-dashed"></div>

              <div class="form-group">
                <div class="col-sm-4 col-sm-offset-2">
                  <router-link class="btn btn-white" to="/faq">
                    Anuluj
                  </router-link>
                  <button
                    v-if="canAddFaq"
                    @click="create"
                    class="btn btn-primary"
                  >
                    Dodaj
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import router from "../../router/router";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import { hasPermission } from "../../permissions";
import { faqPermissionsConst } from "../../constants/settingConstants";

export default {
  name: "FaqCreate",
  mixins: [],
  components: {
    Multiselect,
  },
  props: {},

  setup() {
    const faqObj = ref({
      title_cpde: "",
      title_pl: "",
      title_cpen: "",
      description_en: "",
      title_en: "",
      title_de: "",
      description_de: "",
      description_cpde: "",
      description_cpen: "",
      section: "",
      description_pl: "",
    });
    const faqSections = ref([
      {
        name: "1",
        value: "SECTION_ORDER",
      },
      {
        name: "2",
        value: "SECTION_PAYMENT",
      },
      {
        name: "3",
        value: "SECTION_DELIVERY",
      },
    ]);

    const errorsAdminData = ref();
    const showErrors = ref(false);
    const isPlOpen = ref(true);
    const isEnOpen = ref(true);
    const isDeOpen = ref(true);
    const isDeDeOpen = ref(true);
    const isDeEnOpen = ref(true);
    const isConfigOpen = ref(true);
    const store = useStore();
    const createFaqData = computed(() => store.getters.getCreateFaqData);
    const canAddFaq = computed(() => hasPermission(faqPermissionsConst.add));

    const create = () => {
      if (!canAddFaq.value) {
        return;
      }
      showErrors.value = true;
      store.dispatch("createFaq", faqObj.value);
    };

    watch(
      () => createFaqData.value,
      function (newValue) {
        if (newValue.status === 201) {
          router.push({ name: "FaqList", path: "/faq" }).then(() => {
            store.dispatch("showToaster", {
              type: "success",
              content: "Faq został dodany",
            });
          });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    return {
      faqObj,
      errorsAdminData,
      showErrors,
      create,
      canAddFaq,
      faqSections,
      isPlOpen,
      isEnOpen,
      isDeOpen,
      isDeDeOpen,
      isDeEnOpen,
      isConfigOpen,
    };
  },
  computed: {
    chevronPlClass() {
      return this.isPlOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronEnClass() {
      return this.isEnOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronDeClass() {
      return this.isDeOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronDeDeClass() {
      return this.isDeDeOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronDeEnClass() {
      return this.isDeEnOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronConfigClass() {
      return this.isConfigOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
  },
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}
</style>
